window.addEventListener('DOMContentLoaded', function() {
    function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
        //var nav_height = $("navbarGroup").height() + $("header").height();
        var nav_height = document.getElementById("navbarGroup").offsetHeight + document.getElementById("header").offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop - nav_height;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    $(document).on('click', '.year-selector', function (event) {
        event.preventDefault();
        var nav_height = document.getElementById("navbarGroup").offsetHeight + document.getElementById("header").offsetHeight;
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top - nav_height
        }, 400);

    });

    document.addEventListener('scroll', function (event) {
        if (elementInViewport(document.getElementsByClassName('newsletter')[0])) {
            $('#follower-year-selector').fadeOut('150');

        } else {
            $('#follower-year-selector').fadeIn('300');
        }

        if (!elementInViewport(document.getElementById('page-title-header'))) {
            $('#follower-year-selector').css({top: '22vh', position: 'fixed'})
        } else {
            $('#follower-year-selector').css({top: '0', position: 'relative'})
        }

    }, true /*Capture event*/);

    $('body').scrollspy({target: '#follower-container'})
})
